import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  base64FileHeaderMapper,
  downloadBase64,
  getSharepointCdnFile
} from '../../utilities';
import { ApiService } from '../../constants';

const Image: React.FC<any> = ({
  src,
  alt = null,
  style,
  placeholder = null
}) => {
  const [loading, setLoading] = useState(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (src) {
      setLoading(true);
      setImage(null);
      const url = new URL(String(src));
      if (url.host === new URL(ApiService.imageConfig.isMoodle).host) {
        setLoading(false);
        return setImage(src);
      }
      if (url.host === 'binusianorg.sharepoint.com') {
        downloadBase64(src).then((resp) => {
          setLoading(false);
          if (resp.data && resp.data.resultCode == 200) {
            setImage(base64FileHeaderMapper(resp.data.data));
          }
        });
      } else {
        // getSharepointCdnFile(src).then(resp => {
        //   setLoading(false);
        //   setImage(src);
        // })
        setLoading(false);
        setImage(getSharepointCdnFile(src));
      }
    } else {
      if (placeholder) {
        setLoading(false);
        setImage(placeholder);
      }
    }
  }, [src]);

  return (
    <>
      {loading ? (
        <Skeleton style={style} height={100} />
      ) : (
        <img referrerPolicy="unsafe-url" src={image} style={style} alt={alt} />
      )}
    </>
  );
};

export default Image;
